import { useMutation, useQueryClient } from "@tanstack/react-query";

import { API_URL } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { useUser } from "@/context/user-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export const useDeleteVectorStore = () => {
  const auth = useAuth();
  const userContext = useUser();
  const workspaceId = userContext?.activeWorkspaceId;
  const qc = useQueryClient();

  return useMutation(
    async (params: { vector_store_id: string }) => {
      const response = await fetch(`${API_URL}/api/dashboard/v2/vector-store/delete`, {
        method: "POST",
        headers: jsonAuthHeaders(auth!.userToken!),
        body: JSON.stringify({
          vector_store_id: params.vector_store_id,
          workspace_id: workspaceId,
        }),
      }).then(handleResponse);

      if (response && typeof response === "object" && "success" in response) {
        if (response.success === false) {
          const errorMessage =
            (response as { message?: string }).message || "Failed to delete vector store";
          throw new Error(errorMessage);
        }
      }

      return response;
    },
    {
      onSuccess: () => {
        qc.invalidateQueries({
          queryKey: ["vector-stores", workspaceId],
        });
      },
    },
  );
};
